import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {BadgeForm} from "./BadgeForm";

export const BadgeCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component={Card}>
      <BadgeForm />
    </CustomCreate>
  );
};
